import React, { useEffect, useState } from "react";
import JobCardList from "../job/JobCardList";
import {JobResult} from "../types/job"
import SearchHeader from "../job/SearchHeader";

import ElasticSearchAPIConnector from "@elastic/search-ui-elasticsearch-connector";
// import moment from "moment";

import {
  ErrorBoundary,
  Facet,
  SearchProvider,
  SearchBox,
  PagingInfo,
  Results,
  ResultsPerPage,
  Paging,
  Sorting,
  WithSearch
} from "@elastic/react-search-ui";
import {
  Layout
} from "@elastic/react-search-ui-views";

import CustomPaginationView from "../pagination/CustomPaginationView";

import FacetContainer from "../customFacet";
import {ElasticResultsWrapper} from "@scripts/frontend/job-listing/components/job/ElasticResultsWrapper";
// Common Elasticsearch API settings
const ELASTIC_CONFIG = {
  host: "https://5d0493d4cacf44dbb8a0b25eefe15970.us-east-2.aws.elastic-cloud.com:443",
  apiKey: "X1NVQ1E1Z0I2ZkxkWlpmbzBzN1A6QnpkM1dYazRTVjZ3aUZqR0F1dG1NUQ==",
  jobsIndex: "jobs-north-america",
};

// Elasticsearch Connector for job listings
const connector = new ElasticSearchAPIConnector({
  host: ELASTIC_CONFIG.host,
  index: ELASTIC_CONFIG.jobsIndex,
  apiKey: ELASTIC_CONFIG.apiKey,
});

const config = {
  searchQuery: {
    search_fields: {
      job_title: {
        weight: 3
      },
      job_description: {},
      location: {},
      client_description: {}
    },
    result_fields: {
      job_title: {
        raw: {}
      },
      job_description: {
        snippet: {}
      },
      location: {
        raw: {}
      },
      salary: {
        raw: {}
      },
      job_id: {
        raw: {}
      },
      posted_date: {
        raw: {}
      }
    },
    disjunctiveFacets: [
      "markets.enum",
      "global_filter_category.enum",
      "placement_types.enum",
      "offsite_preference_name.enum"
    ],
    facets: {
      "markets.enum": { type: "value" },
      "global_filter_category.enum": { type: "value", size: 1000 },
      "placement_types.enum": { type: "value" },
      "offsite_preference_name.enum": { type: "value" }
    }
  },
  autocompleteQuery: {
    results: {
      resultsPerPage: 5,
      search_fields: {
        job_title: {
          weight: 3
        }
      },
      result_fields: {
        job_title: {
          snippet: {
            size: 100,
            fallback: true
          }
        }
      }
    }
  },
  apiConnector: connector,
  alwaysSearchOnInitialLoad: true
};

// const CustomResultView = ({ result, onClickLink }) => {
//   if (!result) return null;
//
//   const jobId = result.job_id?.raw || "";
//   const jobTitle = result.job_title?.raw || "";
//   const location = result.location?.raw || "";
//   const postedDate = result.posted_date?.raw || "";
//   const homeUrl = document.getElementById('listing-main')?.getAttribute('data-home-url') || '';
//   const jobBaseUrl = document.getElementById('listing-main')?.getAttribute('data-job-base-url') || '';
//   // Format the date
//   const formattedDate = postedDate
//     ? new Date(postedDate).toLocaleDateString("en-US", {
//         month: "short",
//         day: "numeric",
//         year: "numeric",
//       })
//     : "";
//     // Check if the job is new (posted within the last 7 days)
//     const isNewJob = (postedDate) => {
//       const postedDateObj = new Date(postedDate);
//       const sevenDaysAgo = new Date();
//       sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
//
//       return postedDateObj >= sevenDaysAgo;
//     };
//
//   return (
//     <a
//       href={`/find-work/${jobId}`}
//       title={jobTitle.replace(/<\/?em>/g, "")}
//       className="job-card"
//     >
//       <div
//         className="job-card__block"
//         role="region"
//         aria-labelledby={`job-title-${jobId}`}
//       >
//         <h2 className="job-card__title" id={`job-title-${jobId}`}>
//           {jobTitle.replace(/<\/?em>/g, "")}
//         </h2>
//         <p className="job-card__location">{location}</p>
//         <time className={`job-card__posted ${isNewJob(result.posted_date?.raw) ? "job-card__posted--new" : ""}`} itemProp="datePublished">
//           Posted {formattedDate}
//         </time>
//       </div>
//     </a>
//   );
//
// };

const JobListingMain = () => {

  return (
    <SearchProvider config={config}>
      <WithSearch mapContextToProps={({ resultsPerPage, setResultsPerPage, setSearchTerm }) => ({
        resultsPerPage, setResultsPerPage, setSearchTerm
      })}>
        {({ resultsPerPage, setResultsPerPage, setSearchTerm }) => {
          React.useEffect(() => {
            if (resultsPerPage !== 12) {
              setResultsPerPage(12);
            }
          }, [resultsPerPage, setResultsPerPage]);

          return (
            <div className="job-search">
              <SearchHeader setSearchTerm={setSearchTerm} />
              <ErrorBoundary>
                <Layout
                  header={
                    <div className="job-filter-bar-content filter-bar__content">
                        <div className="filter-bar__combined-menu" id="filter-bar__combined-menu">
                          <a className="filter-bar__combined-menu__a erase-trace" href="#filter-bar__menu">
                          <span className="filter-bar__text-label-mobile">Filters</span>
                            <span className="filter-bar__filter-icon"></span>
                          </a>
                        </div>

                        <div className="filter-bar__menu filter-bar__menu--job" id="filter-bar__menu">
                          <div className="filter-bar__header-mobile">
                            <span className="filter-bar__header-mobile__text">Filters </span>
                            <a className="filter-bar__header-mobile__close-icon erase-trace" href="#filter-bar__content" aria-label="close"></a>
                          </div>
                          <FacetContainer key={"3"} field={"global_filter_category.enum"} label={"Role"} />
                          <FacetContainer key={"2"} field={"placement_types.enum"} label={"Placement Types"} />
                          <FacetContainer key={"1"} field={"markets.enum"} label={"Location"} />
                          <FacetContainer key={"4"} field={"offsite_preference_name.enum"} label={"Location Preference"} />
                        </div>

                      <div className="filter-bar__dropdown-buttons-mobile">
                        <a className="tertiary-info erase-trace" href="/find-work">
                          Clear all
                        </a>
                        <div className="wp-block-button is-style-dark-orange">
                          <button
                            className="wp-block-button__link"
                            onClick={() => {
                              window.location.replace("#filter-bar__content");
                            }}
                          >
                            Show Results
                          </button>
                        </div>
                      </div>

                      <div className="filter-bar__search filter-bar__search-job">
                        {/*<div className="filter-bar__search-field">*/}
                        {/*  <SearchBox*/}
                        {/*  autocompleteMinimumCharacters={3}*/}
                        {/*  autocompleteResults={{*/}
                        {/*    sectionTitle: "Results",*/}
                        {/*    titleField: "job_title",*/}
                        {/*    shouldTrackClickThrough: true*/}
                        {/*  }}*/}
                        {/*  autocompleteSuggestions={true}*/}
                        {/*  inputProps={{ placeholder: "Search jobs and keywords" }}*/}
                        {/*  onSelect={(selection) => {*/}
                        {/*    if (selection && selection.job_title && selection.job_title.snippet) {*/}
                        {/*      let selectedJobTitle = selection.job_title.snippet[0];*/}
                        {/*      selectedJobTitle = selectedJobTitle.replace(/<\/?em>/g, "");*/}
                        {/*      setSearchTerm(selectedJobTitle, { shouldClearFilters: true });*/}
                        {/*    }*/}
                        {/*  }}*/}
                        {/*/>*/}
                        {/*</div>*/}

                        <div className="filter-bar__search-icon" data-aria-label-open="Open Search" data-aria-label-close="Close Search">
                          <div className="filter-bar__search-icon__glass"></div>
                          <a className="filter-bar__search-icon__a erase-trace" href="#downshift-1-input" id="open-search" aria-label="open">
                            <span className="hidden">Open Search</span>
                          </a>
                          <a className="filter-bar__search-icon__a erase-trace" href="#filter-bar__content" id="close-search" aria-label="close">
                            <span className="hidden">Close Search</span>
                          </a>
                        </div>
                      </div>
                    </div>

                  }
                  sideContent={
                    <div>
                      <FacetContainer key={"3"} field={"global_filter_category.enum"} label={"Role"} />
                      <FacetContainer key={"2"} field={"placement_types.enum"} label={"Placement Types"} />
                      <FacetContainer key={"1"} field={"markets.enum"} label={"Location"}  />
                      <FacetContainer key={"4"} field={"offsite_preference_name.enum"} label={"Location Preference"} />
                    </div>
                  }
                  bodyHeader={
                    <>
                      <PagingInfo />
                      <ResultsPerPage />
                    </>
                  }
                  bodyContent={
                    <ElasticResultsWrapper
                    />
                  }

                  bodyFooter={
                    <CustomPaginationView pagingContainer="test"/>
                  }
                />
              </ErrorBoundary>
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
};

export { JobListingMain };
